export const INITIALIZE_CONFIG = 'INITIALIZE_CONFIG';
export const QUERY_PARAM_TERM_UPDATED = 'QUERY_PARAM_TERM_UPDATED';